<h2 mat-dialog-title>Current Submissions</h2>

<mat-dialog-content>
  @if (data.submissions.length === 0) {
    <p class="no-submissions">No submissions found for this organization.</p>
  } @else {
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Search</mat-label>
      <input
        matInput
        #searchInput
        (input)="quickFilterText = searchInput.value"
      />
    </mat-form-field>

    <ag-grid-angular
      class="submissions-grid"
      [columnDefs]="colDefs"
      [rowData]="rowData"
      [defaultColDef]="defaultColDef"
      [theme]="standardTheme"
      [quickFilterText]="quickFilterText"
      [tooltipShowDelay]="300"
      [enableCellTextSelection]="true"
      [pagination]="true"
      [paginationPageSize]="10"
      [paginationPageSizeSelector]="[10, 25, 50]"
    />
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
